var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        { directives: [{ name: "masonry", rawName: "v-masonry" }] },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", lg: "4" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "soli-round",
                  attrs: { disabled: _vm.disablePreferences },
                },
                [
                  _c(
                    "v-container",
                    [
                      _c("v-card-title", { staticClass: "soli-grey" }, [
                        _vm._v("Notifications"),
                      ]),
                      _vm._v(" "),
                      _c("v-card-subtitle", { staticClass: "soli-grey" }, [
                        _vm._v(
                          "\n                        Manage how you receive notifications\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.user.email
                        ? _c(
                            "v-card-text",
                            { staticClass: "px-0 soli-grey" },
                            [
                              _c("NotificationPreferencesForm", {
                                attrs: { rules: _vm.rules },
                                model: {
                                  value: _vm.form.notification_preferences,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "notification_preferences",
                                      $$v
                                    )
                                  },
                                  expression: "form.notification_preferences",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.user.email && _vm.can("Sync calendar")
            ? _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", lg: "4" } },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "soli-round",
                      attrs: { disabled: _vm.disablePreferences },
                    },
                    [
                      _c(
                        "v-container",
                        [
                          _c("v-card-title", { staticClass: "soli-grey" }, [
                            _vm._v("Connections"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-card-subtitle",
                            { staticClass: "soli-grey pb-0" },
                            [
                              _vm._v(
                                "Subscribe to notifications and\n                        calendars"
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          false
                            ? //$page.props.auth.user.id == user.id
                              _c(
                                "div",
                                { staticClass: "absolute top-7 right-6" },
                                [
                                  !_vm.user.google_calendar_id
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            loading: _vm.loading,
                                            small: "",
                                            rounded: "",
                                            outlined: "",
                                            color: "dark",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.syncGoogle()
                                            },
                                          },
                                        },
                                        [
                                          _c("v-img", {
                                            staticClass: "mr-1",
                                            attrs: {
                                              width: "18",
                                              src: "/google.png",
                                            },
                                          }),
                                          _vm._v("Sync Calendar"),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.user.google_calendar_id
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            rounded: "",
                                            outlined: "",
                                            color: "dark",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.confirmCalendarSync = true
                                            },
                                          },
                                        },
                                        [
                                          _c("v-img", {
                                            staticClass: "mr-1",
                                            attrs: {
                                              width: "18",
                                              src: "/google.png",
                                            },
                                          }),
                                          _vm._v("Remove Calendar"),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                [
                                  _c(
                                    "v-list",
                                    {
                                      staticClass: "pt-0",
                                      attrs: { dense: "" },
                                    },
                                    _vm._l(
                                      _vm.relationships,
                                      function (relationship, i) {
                                        return _c(
                                          "v-list-item",
                                          { key: relationship.id },
                                          [
                                            _c("v-switch", {
                                              attrs: {
                                                label: relationship.name,
                                                "hide-details": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.form.syncRelationships[i]
                                                    .email_updates,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form.syncRelationships[
                                                      i
                                                    ],
                                                    "email_updates",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "\n                                            form.syncRelationships[i]\n                                                .email_updates\n                                        ",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.user.email
            ? _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", lg: "4" } },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "soli-round",
                      attrs: { disabled: _vm.disablePreferences },
                    },
                    [
                      _c(
                        "v-container",
                        [
                          _c("v-card-title", { staticClass: "soli-grey" }, [
                            _vm._v(
                              "\n                        Settings\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("v-card-subtitle", { staticClass: "caption" }),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                [
                                  _c(
                                    "v-list",
                                    [
                                      _c(
                                        "v-list-item",
                                        [
                                          _c("v-combobox", {
                                            attrs: {
                                              items: _vm.timezones,
                                              label: "Timezone",
                                              "prepend-inner-icon": "watch",
                                              outlined: "",
                                              rules: _vm.rules.input,
                                              dense: "",
                                              "menu-props": {
                                                closeOnContentClick: true,
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "prepend-item",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "v-list-item",
                                                        {
                                                          attrs: { ripple: "" },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.form.timezone =
                                                                _vm.guessTZ
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item-content",
                                                            [
                                                              _c(
                                                                "v-list-item-title",
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                        Recommended:\n                                                        " +
                                                                      _vm._s(
                                                                        _vm.guessTZ
                                                                      ) +
                                                                      "\n                                                    "
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c("v-divider", {
                                                        staticClass: "mt-2",
                                                      }),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              787795749
                                            ),
                                            model: {
                                              value: _vm.form.timezone,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "timezone",
                                                  $$v
                                                )
                                              },
                                              expression: "form.timezone",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.confirmCalendarSync
        ? _c("SoliChoice", {
            ref: "calendarSync",
            attrs: {
              title: "Are you sure?",
              subtitle: "This will remove your lessons from Google Calendar",
              button1: "Confirm",
              button2: "Nevermind",
              loading1: "",
            },
            on: {
              reset: _vm.closeCalendarSync,
              option1: function ($event) {
                return _vm.deleteCalendar()
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }